module.exports = __webpack_public_path__ + "img/14.heavy-snowfall-light.a696d0e8.svg";